export default __webpack_public_path__ + "static/media/oe-5-lqMAX.919d3db7.jpg";